import PageNotFound from "../../assets/404-error.jpg";

const NotFound = () => {
  return (
    <img style={{ width: "100%", height: "99vh" }} src={PageNotFound} alt="" />
  );
};

export default NotFound;
